<!-- チケット詳細画面のボトムに表示するUI -->
<template>
  <!-- ボトムに設置されるFIXED要素 -->
  <div class="button-container-fixed">
    <!-- queryにkeyがある場合、規約に同意して譲受用アクション -->
    <TheMbReceiveButton v-if="isTransfer" icon="el-icon-s-ticket" :disabled="true" label="受け取る"
      @clicked="openDialogRecieve()" />

    <!-- 外部サイトへ -->
    <ItemButton v-else-if="
      masterBook.content &&
      masterBook.content.description_json &&
      masterBook.content.description_json.GetButton
    " actionType="btn-submit" label="外部サイトへ"
      @clicked="goToExternalLink(masterBook.content.description_json.GetButton)" />

    <!-- バス無料チケット -->
    <ItemButton v-else-if="masterBook.max_purchase_count != 0 && isFreeBus" icon="el-icon-tickets"
      actionType="btn-submit" label="チケットを入手" @clicked="openCamera()" />

    <!-- 藤沢デジタルスタンプラリー -->
    <ItemButton
      v-else-if="masterBook.master_prices[0].price == 0"
      icon="el-icon-tickets"
      actionType="btn-submit"
      label="チケット入手"
      @clicked="goToBooksBooking()"
    />

    <!-- 購入手続きへ -->
    <ItemButton v-else :disabled="!checkIsValidPeriod()" icon="el-icon-shopping-cart-full" actionType="btn-submit"
      :label="$t('TicketStoreTicketing.goToBooking')" @clicked="goToBooksBooking()" />

    <!-- 受け取るボタンをクリックして、確認のダイアログ -->
    <DialogRecieve ref="DialogRecieve" />

    <!--Click the Receive button and the confirmation dialog if Purchase Ticket is an old version.-->
    <DialogPurchaseVersionWarning ref="DialogPurchaseVersionWarning" />
  </div>
</template>

<script>
import DialogRecieve from "@/views/Components/Organisms/TicketStore/Dialog/DialogRecieve";
import DialogPurchaseVersionWarning from "@/views/Components/Organisms/MFITT/Dialog/DialogPurchaseVersionWarning";

import userInfoService from "@/services/userInfo";
import nativeHandlerService from "@/services/nativeHandler";

import { onMounted, ref, watchEffect, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import moment from "@/services/moment";
import masterBookService from "@/services/masterBook";
import { isAppVersionGreater } from "@/lib/compareVersion";

export default {
  name: "TheMbBottom",
  components: {
    DialogRecieve: DialogRecieve,
    DialogPurchaseVersionWarning: DialogPurchaseVersionWarning,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const isTransfer = ref(false);
    const DialogRecieve = ref(null);
    const DialogPurchaseVersionWarning = ref(null);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const device = computed(() => store.getters["common/device"]);
    const appVersion = computed(() => store.getters["common/appVersion"]);
    const isTargetVersionForValidateProfileWithBirthDate = ref(false);
    const isNotTargetVersionForPurchaseTicket = ref(false);
    const isNotTargetVersionForSendingMasterBookId = ref(false);

    const isFreeBus = computed(() => masterBookService.checkIsFreeBus(masterBook.value.id));

    onMounted(() => {
      // 譲渡機能フローの中でユーザーがメールから譲渡URLをクリックしてこのページが開かれた場合はフラグをたてる
      if (route.query.key) {
        isTransfer.value = true;
      }
    });

    // 「購入手続きへ」ボタンタップ
    const goToBooksBooking = async () => {
      const isLogin = store.getters["common/isLogin"];
      if (!isLogin) {
        nativeHandlerService.returnNativeAppToAccountPage();
        return;
      }

      if (isNotTargetVersionForPurchaseTicket.value) {
        openPurchaseVersionWarning();
      } else if (masterBook.value.master_prices[0].price == 0) { // 藤沢デジタルスタンプラリーの場合はクレカ登録チェックをスキップ
        if (await userInfoService.checkProfile(isTargetVersionForValidateProfileWithBirthDate.value)) {
          routePushBooksBooking(true);
        } else {
          console.log("invalid userInfo at goToBooksBooking");
          return;
        }
      } else {
        // ユーザー情報が揃っているか確認
        if (await userInfoService.isValidUserInfo(isTargetVersionForValidateProfileWithBirthDate.value)) {
          routePushBooksBooking();
        } else {
          console.log("invalid userInfo at goToBooksBooking");
          return;
        }
      }
    };

    // 購入ページへ遷移
    const routePushBooksBooking = (is0yenTicket) => {
      router.push({
        name: "BookBooking",
        params: { id: route.params.id },
        query: {
          language: store.getters["common/lang"],
          master_book_set_id: route.query.master_book_set_id,
          is_0yen_ticket: is0yenTicket,
        },
      });
    };

    // 「チケットを入手」ボタンタップ(バス無料チケット) 枚数制限はない
    const openCamera = async () => {
      const isLogin = store.getters["common/isLogin"];
      // 未ログインの場合は、ログインダイアログ表示
      if (!isLogin) {
        nativeHandlerService.returnNativeAppToAccountPage();
        return;
      }

      // プロファイルチェック
      if (await userInfoService.checkProfile(isTargetVersionForValidateProfileWithBirthDate.value)) {
        console.log("object :>> ok");
        if (isNotTargetVersionForSendingMasterBookId.value) {
          await nativeHandlerService.ncOpenCamera("setQR");
        } else {
          await nativeHandlerService.ncOpenCamera("setQR", masterBook.value.id);
        }
      }
    };

    // 受け取りダイアログを表示
    const openDialogRecieve = () => {
      const isLogin = store.getters["common/isLogin"];
      if (!isLogin) {
        nativeHandlerService.returnNativeAppToAccountPage();
        return;
      }

      DialogRecieve.value.openDialog();
    };

    // 現在時刻がstarted_at<現在時刻<limited_at であるかの検証
    // falseの場合ボタンをdisable
    const checkIsValidPeriod = () => {
      var current = moment(new Date());
      var start = moment(new Date(masterBook.value.started_at));
      var limit = moment(new Date(masterBook.value.limited_at));

      return start.isBefore(current) && limit.isAfter(current);
    };

    // 対象のバージョンかどうか確認
    const checkVersion = () => {
      // check version to use birth_date
      let isTargetVersionForValidateProfileWithBirthDateValue = false;

      // Check version to purchase a ticket on an old version
      let isNotTargetVersionForPurchaseTicketValue = false;

      let isNotTargetVersionForSendingMasterBookIdValue = false;

      switch (device.value) {
        case "IOS":
          // check version to use birth_date
          isTargetVersionForValidateProfileWithBirthDateValue = !isAppVersionGreater(appVersion.value, "2.8.2");
          isNotTargetVersionForPurchaseTicketValue = !isAppVersionGreater(appVersion.value, "2.8.3");
          isNotTargetVersionForSendingMasterBookIdValue = !isAppVersionGreater(appVersion.value, "2.8.8");
          break;
        case "ANDROID":
          // check version to use birth_date
          isTargetVersionForValidateProfileWithBirthDateValue = !isAppVersionGreater(appVersion.value, "2.8.3");
          isNotTargetVersionForPurchaseTicketValue = !isAppVersionGreater(appVersion.value, "2.8.4");
          isNotTargetVersionForSendingMasterBookIdValue = !isAppVersionGreater(appVersion.value, "2.8.11");
          break;
        default:
          isTargetVersionForValidateProfileWithBirthDateValue = false;
          isNotTargetVersionForPurchaseTicketValue = false;
          isNotTargetVersionForSendingMasterBookIdValue = false;
          break;
      }

      // check version to use birth_year
      isTargetVersionForValidateProfileWithBirthDate.value =
      isTargetVersionForValidateProfileWithBirthDateValue;

      // Check version to purchase a ticket on an old version
      isNotTargetVersionForPurchaseTicket.value = isNotTargetVersionForPurchaseTicketValue;

      isNotTargetVersionForSendingMasterBookId.value = isNotTargetVersionForSendingMasterBookIdValue;
    };

    const openPurchaseVersionWarning = () => {
      DialogPurchaseVersionWarning.value.openDialog();
    };

    watchEffect(() => {
      if (appVersion.value != null && appVersion.value != undefined) {
        checkVersion();
      }
    });

    return {
      masterBook,
      isFreeBus,
      isTransfer,
      goToBooksBooking,
      openCamera,
      openDialogRecieve,
      openPurchaseVersionWarning,
      DialogRecieve,
      DialogPurchaseVersionWarning,
      checkIsValidPeriod,
    };
  },
};
</script>

<style lang="scss" scoped>
.button-container-fixed {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 0;
  background-color: #ffb206;
  padding: 15px 0;
}

.button-container-fixed button {
  width: calc(100% - 30px);
  margin: auto;
}
</style>
